/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./PreQualification.module.css";
import Header from "../../Header/Header";
// import ProgressBar from "./ProgressBar";
import QuestionForm from "./QuestionForm";
import ProgressBar from "../GeneralInformationForm/ProgressBar";
// import ProgressBar from "../../../components/ProgressBar";

function TitleStepThree() {
    return (
        <main className={`${styles.container} tw-bg-background_color gap-3 `}>
            <Header title="Apply For Title" />

            <QuestionForm />
        </main>
    );
}

export default TitleStepThree;
